import { render } from "./Course.vue?vue&type=template&id=163df32d&scoped=true"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"

import "./Course.vue?vue&type=style&index=0&id=163df32d&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/外网-学校主页/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163df32d"]])

export default __exports__